import { render, staticRenderFns } from "./submitCatAudit.vue?vue&type=template&id=7c0d9d4b&scoped=true"
import script from "./submitCatAudit.vue?vue&type=script&lang=js"
export * from "./submitCatAudit.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c0d9d4b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城平台端\\fhj-web-dyh-admin\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7c0d9d4b')) {
      api.createRecord('7c0d9d4b', component.options)
    } else {
      api.reload('7c0d9d4b', component.options)
    }
    module.hot.accept("./submitCatAudit.vue?vue&type=template&id=7c0d9d4b&scoped=true", function () {
      api.rerender('7c0d9d4b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/videoChannel/weChatcategoryAndBrand/submitCatAudit.vue"
export default component.exports